import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import type { IGetPaymentResponse } from "../apis/payment/type";

type TSubscriptionPaymentStore = {
  subscriptionPaymentList: Array<IGetPaymentResponse> | null | undefined;
  setsubscriptionPaymentList: (
    subscriptionPaymentList: Array<IGetPaymentResponse> | null | undefined
  ) => void;
};

const initState = {
  subscriptionPaymentList: undefined,
};

const useSubscriptionPaymentStore = create<TSubscriptionPaymentStore>()(
  immer((set) => ({
    ...initState,
    setsubscriptionPaymentList: (
      subscriptionPaymentList: Array<IGetPaymentResponse> | null | undefined
    ) => {
      const sortedList = subscriptionPaymentList?.sort((a, b) => b.id - a.id);

      set((state) => ({
        ...state,
        subscriptionPaymentList: sortedList || null,
      }));
    },
  }))
);

export default useSubscriptionPaymentStore;
